import { Box, Modal } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useMemo, useRef, useState } from "react";
import UploadStudentAnswerModal from "../components/Competitions/UploadStudentAnswerModal";
import Loader from "../components/general/Loader";
import LoadingBackdrop from "../components/general/LoadingBackdrop";
import NoData from "../components/general/NoData";
import ReusableButton from "../components/general/ReusableButton";
import AddParticipatingCountryModal from "../components/modal/AddParticipatingCountryModal";
import DeleteModal from "../components/modal/DeleteModal";
import HeavyTable from "../components/table/HeavyTable";
import PageHeader from "../components/ui/PageHeader";
import SearchInput from "../components/ui/SearchInput";
import TableCard from "../components/ui/TableCard";
import TableToolbar from "../components/ui/TableToolbar";
import { useLegacyFilters } from "../components/ui/useFilterDrawer";
import { showWarningSwal } from "../functions/alert";
import {
  isAdmin,
  isPartner,
  isPartnerOrAssistant,
} from "../functions/checkrole";
import { deleteCompetition } from "../functions/deleteData";
import {
  cancelAction,
  changeFiltered,
  changeRowsPerPage,
  changeSearch,
  changeViewOptions,
  loadData,
  makeOptions,
  makeSureIsArray,
  resetAll,
} from "../functions/general";
import { getCompetitions } from "../functions/getData";
import { showNotification } from "../functions/snackbar";
const competitionHeader = () =>
  [
    { id: "name", label: "Competition" },
    { id: "status", label: "Status" },
    { id: "marked_manually", label: "Marked Manually" },
    // { id: 'description', label: 'Description' },
    isPartner()
      ? {
          id: "registration_open_date",
          label: isPartnerOrAssistant()
            ? "Country Registration Date"
            : "Registration Date",
        }
      : { id: "global_registration_date", label: "Global Registration Date" },
    {
      id: "competition_start_date",
      label: isPartnerOrAssistant()
        ? "Country Competition Start"
        : "Competition Start",
    },
    {
      id: "competition_end_date",
      label: isPartnerOrAssistant()
        ? "Country Competition End"
        : "Competition End",
    },
    { id: "tags", label: "Tags" },
    isAdmin() && { id: "competition_organization", label: "Organization" },
    { id: "format", label: "Format" },
    // { id: 'rounds', label: 'Rounds' },
    // { id: 'tags', label: 'Tags' },
    // { id: 'levels', label: 'Levels' },
    // { id: 'awards', label: 'Awards' },
  ].filter(Boolean);
const initialParams = "?limits=10";
export default function Competitions() {
  document.title = "Competition";
  const isMounted = useRef(false);
  const [header, setHeader] = useState(competitionHeader());
  const [competitionTable, setCompetitionTable] = useState();
  const [filtered, setFiltered] = useState([
    { label: "Format", state: "", key: "format", header: "format" },
    { label: "Status", state: "", key: "status", header: "status" },
    { label: "Tags", state: [], key: "tag_id", header: "tags" },
  ]);
  const [filterOptions, setFilterOptions] = useState();
  const [viewOptions, setViewOptions] = useState(
    [
      // { label: "Rounds", state: true, key: 'created_by_username' },
      // { label: "Levels", state: true, key: 'created_by_username' },
      // { label: "Awards", state: true, key: 'created_by_username' },
      isAdmin() && {
        label: "organization",
        state: true,
        key: "competition_organization",
      },
      { label: "Format", state: true, key: "format" },
      { label: "Status", state: true, key: "status" },
    ].filter(Boolean)
  );
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [params, setParams] = useState(initialParams);
  const [loading, setLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [firstLoaded, setFirstLoaded] = useState(false);
  const [id, setId] = useState("");
  const [selected, setSelected] = useState([]);
  const [selecting, setSelecting] = useState([]);
  const [onDelete, setOnDelete] = useState(false);
  const [onAddPartner, setOnAddPartner] = useState(false);
  const [onUpload, setOnUpload] = useState(false);
  const cancelDelete = () => cancelAction(setOnDelete, setId);
  const cancelAddPartner = () => cancelAction(setOnAddPartner, setId);
  const cancelUpload = () => cancelAction(setOnUpload, setId);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const afterFunction = (cancel, data) => {
    if ([200, 201].includes(data.status)) {
      resetAll(initialParams, filtered, setParams, setSearch, setFiltered);
      getData(initialParams, signal);
      cancel();
      showNotification("success", data.message, enqueueSnackbar, closeSnackbar);
      setSelected([]);
      setSelecting([]);
    }
  };
  const deleteFunction = () => {
    setLoading(true);
    deleteCompetition({ id: id === "" ? selected : [id] })
      .then((d) => {
        afterFunction(cancelDelete, d);
      })
      .catch((e) => console.log(e))
      .finally(() => isMounted.current && setLoading(false));
  };
  const getData = (params, signal) => {
    setSelected([]);
    setSelecting([]);
    loadData(
      setLoadingTable,
      setFirstLoaded,
      getCompetitions,
      params,
      setCompetitionTable,
      setFilterOptions,
      isPartnerOrAssistant() && { title: "competition" },
      signal
    );
  };
  const onChangeViewOptions = (value) =>
    changeViewOptions(competitionHeader(), setViewOptions, setHeader, value);
  const onChangeRowsPerPage = (value) => {
    changeRowsPerPage(
      value,
      rowsPerPage,
      filtered,
      search,
      signal,
      setRowsPerPage,
      setParams,
      getData
    );
  };
  const onChangeFiltered = (value) => {
    console.log(value);
    changeFiltered(
      value,
      filtered,
      search,
      rowsPerPage,
      signal,
      setFiltered,
      setParams,
      getData
    );
  };
  const onChangeSearch = (value) => {
    changeSearch(
      value,
      search,
      filtered,
      rowsPerPage,
      signal,
      setSearch,
      setParams,
      getData
    );
  };

  const formatData = (competitionTable) => {
    console.log(competitionTable);
    let data = makeSureIsArray(competitionTable.data).map((item) => ({
      ...item,
      marked_manually: item.rounds?.[0]?.marked_manually ? "Yes" : "No",
    }));
    return { ...competitionTable, data: data };
  };
  const onChangePage = (pageNo) => getData(`${params}&page=${pageNo}`, signal);
  const controller = useMemo(() => new AbortController(), []);
  const signal = controller.signal;
  useEffect(() => {
    isMounted.current = true;
    getData(initialParams, signal);
    return () => {
      controller.abort();
      isMounted.current = false;
    };
  }, [controller, signal]);
  const onClickMassDelete = () => {
    return selected.length
      ? setOnDelete(true)
      : showWarningSwal(
          "Please select at least one competition to mass delete"
        );
  };
  console.log(filterOptions);
  // console.log(filtered.map(f => makeOptions(filterOptions, f.header)))
  const legacyFilters = useLegacyFilters({
    filtered,
    filterOptions:
      filterOptions && filtered.map((f) => makeOptions(filterOptions, f.header)),
    onChangeFiltered,
  });
  const total = competitionTable?.total ?? competitionTable?.meta?.total;
  return (
    <Box className="wrapperBox simcc-page">
      <LoadingBackdrop loading={loading} />
      <PageHeader
        title="Competitions"
        actions={
          isAdmin() && (
            <>
              <ReusableButton
                variant="danger"
                text="Mass Delete"
                onClick={() => onClickMassDelete()}
                iconType="delete"
              />
              <ReusableButton
                variant="primary"
                text="Add Competition"
                to="/addcompetition"
                iconType="add"
              />
            </>
          )
        }
      />
      <TableCard
        toolbar={
          <TableToolbar
            search={
              <SearchInput
                state={search}
                setState={onChangeSearch}
                placeholder="Search by competition name"
              />
            }
            onOpenFilters={filterOptions ? legacyFilters.openDrawer : undefined}
            filtersOpen={legacyFilters.isOpen}
            filterCount={legacyFilters.count}
            meta={total !== undefined && `${Number(total).toLocaleString()} competitions`}
          />
        }
        chips={legacyFilters.chips}
      >
        {loadingTable && <Loader height={400} />}
        {!loadingTable &&
          competitionTable &&
          !!makeSureIsArray(competitionTable.data).length && (
            <HeavyTable
              bare
              headers={header}
              list={formatData(competitionTable)}
              title="competitions"
              rowsPerPage={rowsPerPage}
              onChangeRowsPerPage={onChangeRowsPerPage}
              setOnDelete={setOnDelete}
              onChangePage={onChangePage}
              fixed={["name"]}
              selecting={selecting}
              setSelecting={setSelecting}
              selected={selected}
              setSelected={setSelected}
              setId={setId}
              setOnAddUser={setOnAddPartner}
              setOnUpload={setOnUpload}
            />
          )}
        {!loadingTable &&
          firstLoaded &&
          competitionTable &&
          !makeSureIsArray(competitionTable.data).length && (
            <NoData height={400} />
          )}
      </TableCard>
      {legacyFilters.drawer}
      <Modal open={onAddPartner} onClose={() => cancelAddPartner()}>
        <>
          {competitionTable && (
            <AddParticipatingCountryModal
              setLoading={setLoading}
              table={competitionTable}
              id={id}
              cancelAddCompetitionOrganization={cancelAddPartner}
              afterAddingPartner={afterFunction}
            />
          )}
        </>
      </Modal>
      <Modal open={onDelete} onClose={() => cancelDelete()}>
        <>
          {competitionTable && (
            <DeleteModal
              table={competitionTable}
              id={id}
              selected={selected}
              deleteFunction={deleteFunction}
              cancelDelete={cancelDelete}
            />
          )}
        </>
      </Modal>
      <Modal open={onUpload} onClose={() => cancelUpload()}>
        <>
          {competitionTable && (
            <UploadStudentAnswerModal
              setLoading={setLoading}
              setOnUpload={setOnUpload}
              table={competitionTable}
              id={id}
              afterUploadingAnswer={afterFunction}
            />
          )}
        </>
      </Modal>
    </Box>
  );
}
